import script from "./ContentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentLayout.vue?vue&type=script&setup=true&lang=js"

import "./ContentLayout.vue?vue&type=style&index=0&id=388a94b6&lang=css"

const __exports__ = script;

export default __exports__